import { render, staticRenderFns } from "./EpisodesList.vue?vue&type=template&id=7b176a64&scoped=true"
import script from "./EpisodesList.vue?vue&type=script&lang=ts&setup=true"
export * from "./EpisodesList.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./EpisodesList.vue?vue&type=style&index=0&id=7b176a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b176a64",
  null
  
)

export default component.exports